// extracted by mini-css-extract-plugin
export default {"link":"Redeem_link__RAV3A","no_hover":"Redeem_no_hover__a31bZ"};